import React from 'react';
import Button from './Button';

interface PopupPropsBase {
  hideTop?: boolean;
  onClose: () => void;
}

type PopupProps = PopupPropsBase & React.HTMLProps<HTMLDivElement>;

function Popup(props: PopupProps) {
  const { children, className: propClasses, hideTop, onClose, ...rest } = props;

  function handleInnerClick(event: React.MouseEvent<HTMLDivElement>) {
    event.stopPropagation();
  }

  const classes = ['popup-container pb-8 backdrop-blur'];
  if (propClasses) {
    classes.push(propClasses);
  }

  return (
    <>
      {!hideTop && (
        <Button
          outline="border-black"
          shape="circle"
          size={20}
          className="popup-close text-3xl text-white bg-black"
          icon={['far', 'xmark']}
          onClick={onClose}
          style={{ zIndex: 100 }}
        />
      )}
      <div
        {...rest}
        className={classes.join(' ')}
        onClick={onClose}
        style={{
          top: hideTop ? 76 : 0,
          height: `calc(100% - ${hideTop ? 76 : 0}px)`,
          zIndex: 99,
        }}
      >
        {!hideTop && (
          <div
            className="w-full"
            onClick={onClose}
            style={{
              height: 76,
            }}
          ></div>
        )}
        <div className="relative" onClick={handleInnerClick}>
          {children}
        </div>
      </div>
    </>
  );
}

export default Popup;
